import React from 'react';
import LoadingIcon from '../../../../LoadingIcon';
import CountryService from '../../../../../Services/CountryService';
import MultiChoice from './MultiChoice';
import ErrorMessage from '../../../../ErrorMessage';

export default class CountryMultiChoice extends React.Component {
  static defaultProps = {
    label: '',
    onChange: () => alert('CountryMultiChoice Onchange'),
    selected: [],
    useCountryCode: false,
    useCountryName: false,
    fieldName: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selected: null,
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.populateListData();
    }
  }

  populateListData() {
    CountryService.GetCountryList()
      .then((result) => {
        const optValues = [];
        const selected = [];
        result.forEach((country) => {
          if (!country.name?.includes('DO NOT USE')) {
            const newValue = {
              label: country.name,
              value: this.props.useCountryCode
                ? country.code
                : this.props.useCountryName
                ? country.name
                : country.countryId,
            };
            optValues.push(newValue);
            if (
              this.props.selected && this.props.useCountryCode
                ? this.props.selected?.includes(country.code)
                : this.props.selected && this.props.useCountryName
                ? this.props.selected?.includes(country.name)
                : this.props.selected?.includes(country.countryId)
            ) {
              selected.push(newValue);
            }
          }
        });
        this.setState({
          itemList: optValues,
          loading: false,
          selected: selected,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('COMC64', error));
  }

  multiSelectOnChange(selected) {
    this.setState({ selected });
    this.props.onChange(selected);
  }

  renderList() {
    return (
      <MultiChoice
        label=''
        p-multiselect-panel={true}
        className='rmsc'
        options={this.state.itemList}
        selected={this.props.selected}
        value={this.state.selected}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className='w-100 text-center hover rounded arial'>
        {this.props.label && (
          <label
            className='m-0 p-0 defaultfontsize '
            htmlFor={'htmlidfor' + this.props.fieldName}
          >
            {this.props.label}
          </label>
        )}
        {this.state.loading ? (
          <LoadingIcon
            loading={true}
            className='h6'
          />
        ) : (
          this.renderList()
        )}
      </div>
    );
  }
}
